import { useEffect, useRef, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./Surgeries.css";
import {
    DatosGenerales,
    Enfermeria,
    TecnicaQuirurgica,
    FichaAnestesica,
    Insumo,
} from "./InputsData";
import { useParams } from "react-router-dom";
import api from "../../api";
import {
    CheckCircleIcon,
    ExclamationCircleIcon,
    XMarkIcon,
} from "@heroicons/react/24/outline";

export function SurgeryData() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [isNew, setIsNew] = useState(true);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [formErrors, setFormErrors] = useState({
        schedule: { message: null, tab: 0 },
        patient: { message: null, tab: 0 },
        wasCanceled: { message: null, tab: 0 },
        cancellationReason: { message: null, tab: 0 },
        isPrivatePatient: { message: null, tab: 0 },
        operatingRoom: { message: null, tab: 0 },
        surgeryDate: { message: null, tab: 0 },
        startTime: { message: null, tab: 0 },
        endTime: { message: null, tab: 0 },
        preoperativeDiagnosis: { message: null, tab: 0 },
        nurse: { message: null, tab: 1 },
        preoperativeDiagnosisNursing: { message: null, tab: 1 },
        surgicalTechnique: { message: null, tab: 2 },
        anesthesiaType: { message: null, tab: 3 },
        patientResponses: { message: null, tab: 3 },
        surgicalComplications: { message: null, tab: 3 },
        usedSupplies: { message: [], tab: 4 },
    });
    const { idSurgery } = useParams();
    const [nurse, setNurse] = useState([]);
    const [surgerySchedules, setSurgerySchedules] = useState(false);
    const messageRef = useRef(null);
    const [surgeryData, setSurgeryData] = useState({
        schedule: null,
        patient: null,
        wasCanceled: true,
        cancellationReason: "",
        isPrivatePatient: true,
        operatingRoom: 1,
        surgeryDate: "",
        startTime: "",
        endTime: "",
        preoperativeDiagnosis: "",
        nurse: null,
        preoperativeDiagnosisNursing: "",
        surgicalTechnique: "",
        anesthesiaType: "",
        patientResponses: "",
        surgicalComplications: "",
        usedSupplies: [],
    });

    const handleChange = (field, value) => {
        setSurgeryData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setFormErrors((prev) => ({
            ...prev,
            [field]: { ...prev[field], message: null },
        }));
    };

    useEffect(() => {
        api.surgicalProcedures
            .getMulti(null, null, null, null, { schedule: idSurgery })
            .then((response) => {
                if (response.length > 0) {
                    setSurgeryData(response[0]);
                    setIsNew(false);
                }
            })
            .catch((error) => {
                console.error("Error al obtener la cirugía:", error);
            });
        api.doctors
            .getMulti(null, null, null, null, { role: 5 })
            .then((response) => {
                const doctorsOptions = response.map((item) => ({
                    id: item.id,
                    name: item.firstName + " " + item.lastName,
                }));
                setNurse(doctorsOptions);
            });
        api.surgerySchedules.getOne(idSurgery).then((response) => {
            const { date, patient, id } = response;
            setSurgerySchedules(response);
            setSurgeryData((prev) => ({
                ...prev,
                surgeryDate: date,
                patient: patient.id,
                schedule: id,
            }));
        });
    }, [idSurgery]);

    const tabs = [
        {
            name: "Datos Generales",
            content: (
                <DatosGenerales
                    surgeryData={surgeryData}
                    handleChange={handleChange}
                    setSurgeryData={setSurgeryData}
                    surgerySchedules={surgerySchedules}
                    formErrors={formErrors}
                />
            ),
        },
        {
            name: "Enfermería",
            content: (
                <Enfermeria
                    surgeryData={surgeryData}
                    setSurgeryData={setSurgeryData}
                    nurse={nurse}
                    formErrors={formErrors}
                />
            ),
        },
        {
            name: "Técnica Quirúrgica",
            content: (
                <TecnicaQuirurgica
                    surgeryData={surgeryData}
                    handleChange={handleChange}
                    formErrors={formErrors}
                    setSurgeryData={setSurgeryData}
                />
            ),
        },
        {
            name: "Ficha Anestésica",
            content: (
                <FichaAnestesica
                    surgeryData={surgeryData}
                    handleChange={handleChange}
                    medicals={nurse}
                    formErrors={formErrors}
                />
            ),
        },
        {
            name: "Insumo",
            content: (
                <Insumo
                    surgeryData={surgeryData}
                    handleChange={handleChange}
                    formErrors={formErrors}
                />
            ),
        },
    ];

    const handleSubmit = async (event) => {
        event.preventDefault();
        const newErrors = {
            surgeryDate:
                surgeryData.surgeryDate.trim() === ""
                    ? {
                          message: "Este campo es obligatorio",
                          tab: formErrors.surgeryDate.tab,
                      }
                    : { ...formErrors.surgeryDate, message: null },

            startTime:
                surgeryData.startTime.trim() === ""
                    ? {
                          message: "Este campo es obligatorio",
                          tab: formErrors.startTime.tab,
                      }
                    : { ...formErrors.startTime, message: null },

            endTime:
                surgeryData.endTime.trim() === ""
                    ? {
                          message: "Este campo es obligatorio",
                          tab: formErrors.endTime.tab,
                      }
                    : { ...formErrors.endTime, message: null },

            preoperativeDiagnosis:
                surgeryData.preoperativeDiagnosis.trim() === ""
                    ? {
                          message: "Este campo es obligatorio",
                          tab: formErrors.preoperativeDiagnosis.tab,
                      }
                    : { ...formErrors.preoperativeDiagnosis, message: null },
        };
        setFormErrors((prev) => ({
            ...prev,
            ...newErrors,
        }));
        const hasErrors = Object.values(newErrors).some(
            (error) => error.message
        );
        if (hasErrors) {
            setActiveTab(0);
            return;
        }
        setLoading(true);
        try {
            if (isNew) {
                await api.surgicalProcedures.create(surgeryData);
            } else {
                await api.surgicalProcedures.update(
                    surgeryData.id,
                    surgeryData
                );
            }
            messageRef.current?.showModal();
        } catch (error) {
            console.error("Error al guardar datos de la cirugía:", error);
            if (error?.message && typeof error.message === "object") {
                const messagesByField = error.message;
                const fieldsInError = Object.keys(messagesByField);
                const formErrorFields = Object.keys(formErrors);
                const hasFieldError = fieldsInError.some((field) =>
                    formErrorFields.includes(field)
                );
                if (hasFieldError) {
                    setFormErrors((prevErrors) => {
                        const newFormErrors = { ...prevErrors };
                        for (const field in messagesByField) {
                            newFormErrors[field] = {
                                ...newFormErrors[field],
                                message: messagesByField[field] || null,
                            };
                            setActiveTab(newFormErrors[field].tab);
                        }
                        return newFormErrors;
                    });
                } else {
                    setErrorMessage(
                        typeof error.message === "string"
                            ? error.message
                            : "Ocurrió un error inesperado."
                    );
                    messageRef.current?.showModal();
                }
            } else {
                setErrorMessage(error.message || "Error desconocido");
                messageRef.current?.showModal();
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="bg-gray-100 h-screen">
            <Sidebar
                currentScreen={"Cirugías"}
                sidebarOpen={sidebarOpen}
                setSidebarOpen={setSidebarOpen}
            />
            <div className="md:pl-64 flex flex-col h-screen flex-1">
                <>
                    <Header setSidebarOpen={setSidebarOpen} />
                    <main className="flex-1 space-y-6 bg-gray-100 py-8 px-6 lg:pl-8 lg:pr-32">
                        <form onSubmit={handleSubmit}>
                            <Tabs
                                tabs={tabs}
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                            />
                            <div className="w-full flex justify-end mt-6">
                                <button
                                    type="submit"
                                    className="flex items-center px-4 py-2 border border-transparent shadow-sm text-lg font-semibold rounded-md text-white bg-primary hover:bg-primary disabled:bg-gray-300 disabled:text-black disabled:border-primary disabled:cursor-not-allowed"
                                >
                                    Guardar
                                </button>
                            </div>
                        </form>
                    </main>
                </>
            </div>
            <dialog
                ref={messageRef}
                id="new-surgery"
                closedby="any"
                className="rounded-lg overflow-visible"
            >
                <MessageModal
                    dialogRef={messageRef}
                    loading={loading}
                    errorMessage={errorMessage}
                />
            </dialog>
        </div>
    );
}

const MessageModal = ({ dialogRef, loading, errorMessage }) => {
    return (
        <div className="px-10 pt-6 pb-10">
            <div className="flex flex-row justify-end">
                <button
                    type="button"
                    className="hover:bg-black hover:bg-opacity-10 p-1 rounded transition-all"
                    onClick={() => dialogRef.current?.close()}
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>
            {loading ? (
                <div className="flex h-full items-center justify-center ">
                    <div className="w-16 h-16 border-b-2 border-blue-900 rounded-full animate-spin"></div>
                </div>
            ) : errorMessage ? (
                <div className="flex flex-col gap-4 justify-center items-center text-center text-red-600">
                    <ExclamationCircleIcon className="h-24 w-24 text-red-600" />
                    <p className="font-bold">Ocurrió un error</p>
                    <p className="whitespace-pre-line text-center">
                        {errorMessage}
                    </p>
                </div>
            ) : (
                <div className="flex flex-col gap-6 justify-center items-center">
                    <CheckCircleIcon className="h-24 w-24 text-primary" />
                    <p className="font-bold">Datos guardados con éxito</p>
                </div>
            )}
        </div>
    );
};

const Tabs = ({ tabs, activeTab, setActiveTab }) => {
    return (
        <div>
            <div className="flex gap-4 max-w-[100dvh] lg:max-w-full overflow-auto">
                {tabs.map((tab, index) => (
                    <label
                        key={tab.name}
                        className={`uppercase font-semibold rounded-lg py-3 px-4 cursor-pointer ${
                            activeTab === index
                                ? "bg-[#48B7E940] text-[#48B7E9]"
                                : "hover:bg-[#48B7E940] text-gray-500"
                        } `}
                    >
                        <input
                            type="radio"
                            name="tabs"
                            value={index}
                            checked={activeTab === index}
                            onChange={() => setActiveTab(index)}
                            className="hidden"
                        />
                        {tab.name}
                    </label>
                ))}
            </div>
            <div className="mt-6">{tabs[activeTab].content}</div>
        </div>
    );
};
